export default "__VITE_ASSET__D1urw9JH__"